import React, { useEffect, createElement } from 'react';
import { MailIcon, MessageCircleIcon, GiftIcon } from 'lucide-react';
import { FacebookPixel } from './FacebookPixel';
export function YtJuevesThankYouPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    if (window.fbq) {
      window.fbq('track', 'Lead');
    }
  }, []);
  useEffect(() => {
    // Load Google Ads gtag.js
    const gtagScript = document.createElement('script');
    gtagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-11106102578';
    gtagScript.async = true;
    gtagScript.onerror = () => {
      console.error('Failed to load Google Ads gtag.js script');
    };
    document.head.appendChild(gtagScript);
    // Initialize gtag and fire conversion
    const gtagInitScript = document.createElement('script');
    gtagInitScript.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'AW-11106102578');
      gtag('event', 'conversion', {'send_to': 'AW-11106102578/i53xCOT5nN0bELLa5q8p'});
    `;
    document.head.appendChild(gtagInitScript);
    return () => {
      try {
        if (document.head.contains(gtagScript)) {
          document.head.removeChild(gtagScript);
        }
        if (document.head.contains(gtagInitScript)) {
          document.head.removeChild(gtagInitScript);
        }
      } catch (error) {
        console.error('Error cleaning up Google Ads scripts:', error);
      }
    };
  }, []);
  return <div className="min-h-screen w-full bg-gradient-to-b from-gray-900 to-black text-white" data-id="element-916">
      <FacebookPixel pixelId="754551913878347" data-id="element-917" />

      {/* Header */}
      <header className="fixed top-0 left-0 right-0 z-40 w-full px-4 py-2 bg-gray-900 bg-opacity-80 backdrop-blur-lg border-b border-gray-800 h-[88px]" data-id="element-918">
        <div className="flex flex-col items-center justify-center h-full gap-0.5" data-id="element-919">
          <div className="w-full max-w-[600px] h-[40px] flex items-center justify-center px-4" data-id="element-920">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/gqSiWiuARq6wcs7g3ZrS3R/TRUSTED_BADGE.png" alt="Trusted by 1000+ Verified Customers" className="w-full h-auto max-h-[40px] object-contain" data-id="element-921" />
          </div>
          <div className="w-[100px] h-[28px] flex items-center justify-center" data-id="element-922">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/9nsoAdMCr2MakXFCqq5bSP/gb_signature.png" alt="Signature" className="w-full h-auto max-w-[100px]" width="100" height="28" data-id="element-923" />
          </div>
        </div>
      </header>

      {/* Main Content */}
      <main className="pt-24 md:pt-[112px] pb-8 md:pb-16" data-id="element-924">
        <div className="container mx-auto px-4 md:px-6 lg:px-8 max-w-4xl" data-id="element-925">
          {/* Date Confirmation Banner */}
          <div className="bg-red-600 bg-opacity-20 border-2 border-red-500 rounded-lg md:rounded-xl p-3 md:p-6 mb-4 md:mb-8 text-center" data-id="element-926">
            <h1 className="text-lg md:text-3xl font-bold text-white mb-1" data-id="element-927">
              Reservada La Fecha: Jueves 29 | 7PM EST
            </h1>
            <p className="text-base md:text-2xl text-red-300 font-semibold" data-id="element-928">
              Tu lugar está confirmado
            </p>
          </div>

          {/* Main Heading */}
          <div className="text-center mb-6 md:mb-12" data-id="element-929">
            <h2 className="text-2xl md:text-4xl lg:text-5xl font-bold text-white mb-2 md:mb-4 leading-tight" data-id="element-930">
              Completa Estos 3 Pasos Importantes
            </h2>
            <p className="text-base md:text-xl text-gray-300" data-id="element-931">
              Para aprovechar al máximo el AI Infocommerce Masterclass
            </p>
          </div>

          {/* Step 1: Email */}
          <div className="bg-gray-800 bg-opacity-50 rounded-lg md:rounded-2xl p-4 md:p-8 mb-4 md:mb-8 border-2 border-gray-700" data-id="element-932">
            <div className="flex items-start mb-3 md:mb-6" data-id="element-933">
              <div className="bg-red-600 rounded-full p-2 md:p-4 mr-3 md:mr-6 flex-shrink-0" data-id="element-934">
                <MailIcon className="h-5 w-5 md:h-8 md:w-8 text-white" data-id="element-935" />
              </div>
              <div data-id="element-936">
                <h3 className="text-xl md:text-3xl font-bold text-white mb-1 md:mb-2" data-id="element-937">
                  Paso #1: Revisa Tu Email
                </h3>
                <p className="text-red-400 font-semibold text-sm md:text-lg" data-id="element-938">
                  Acción Necesaria Ahora
                </p>
              </div>
            </div>
            <p className="text-gray-300 text-sm md:text-lg leading-relaxed" data-id="element-939">
              Revisa tu email para confirmar tu acceso y continúa con los pasos
              siguientes.
            </p>
          </div>

          {/* Step 2: WhatsApp */}
          <div className="bg-gray-800 bg-opacity-50 rounded-lg md:rounded-2xl p-4 md:p-8 mb-4 md:mb-8 border-2 border-gray-700" data-id="element-940">
            <div className="flex items-start mb-3 md:mb-6" data-id="element-941">
              <div className="bg-green-600 rounded-full p-2 md:p-4 mr-3 md:mr-6 flex-shrink-0" data-id="element-942">
                <MessageCircleIcon className="h-5 w-5 md:h-8 md:w-8 text-white" data-id="element-943" />
              </div>
              <div data-id="element-944">
                <h3 className="text-xl md:text-3xl font-bold text-white mb-1 md:mb-2" data-id="element-945">
                  Paso #2: Únete Al Grupo De Whatsapp
                </h3>
              </div>
            </div>

            <a href="https://chat.whatsapp.com/DL44ZORlCwD5DcWG4MUYLE" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full bg-green-600 hover:bg-green-700 active:bg-green-800 text-white text-base md:text-xl font-bold py-3 md:py-5 px-6 md:px-8 rounded-lg shadow-xl transform hover:scale-105 active:scale-95 transition-all duration-300 mb-3 md:mb-6" data-id="element-946">
              <svg className="h-5 w-5 md:h-7 md:w-7 mr-2 md:mr-3 flex-shrink-0" fill="currentColor" viewBox="0 0 24 24" data-id="element-947">
                <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z" data-id="element-948" />
              </svg>
              Unirme al grupo
            </a>

            <p className="text-gray-300 text-sm md:text-lg leading-relaxed" data-id="element-949">
              Únete a nuestro grupo privado exclusivo para los asistentes
            </p>
          </div>

          {/* Step 3: Gift Guide */}
          <div className="bg-gray-800 bg-opacity-50 rounded-lg md:rounded-2xl p-4 md:p-8 mb-6 md:mb-12 border-2 border-gray-700" data-id="element-950">
            <div className="flex items-start mb-3 md:mb-6" data-id="element-951">
              <div className="bg-yellow-600 rounded-full p-2 md:p-4 mr-3 md:mr-6 flex-shrink-0" data-id="element-952">
                <GiftIcon className="h-5 w-5 md:h-8 md:w-8 text-white" data-id="element-953" />
              </div>
              <div data-id="element-954">
                <h3 className="text-xl md:text-3xl font-bold text-white mb-1 md:mb-2" data-id="element-955">
                  Paso #3: Regalo Exclusivo
                </h3>
              </div>
            </div>

            <div className="mb-3 md:mb-6" data-id="element-956">
              <a href="https://drive.google.com/file/d/1UwCS-6hTXssQIqMUObPKvMnumSsTNm5u/view" target="_blank" rel="noopener noreferrer" className="block" data-id="element-957">
                <img src="https://cdn.magicpatterns.com/uploads/v4rrw1j1xw3cfPqMvAUQyj/Banner_Secuencia_Correcta.png" alt="Guía de la Secuencia Correcta" className="w-full h-auto rounded-lg md:rounded-xl shadow-2xl hover:scale-105 transition-transform duration-300" data-id="element-958" />
              </a>
            </div>

            <a href="https://drive.google.com/file/d/1UwCS-6hTXssQIqMUObPKvMnumSsTNm5u/view" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full bg-yellow-600 hover:bg-yellow-700 active:bg-yellow-800 text-white text-base md:text-xl font-bold py-3 md:py-5 px-6 md:px-8 rounded-lg shadow-xl transform hover:scale-105 active:scale-95 transition-all duration-300 mb-3 md:mb-6" data-id="element-959">
              Descargar guía
            </a>

            <p className="text-gray-300 text-sm md:text-base leading-relaxed" data-id="element-960">
              Esta guía te ayudará a llegar al workshop con el marco mental
              correcto y entender el orden correcto para aprovechar el contenido
              desde el primer minuto.
            </p>
          </div>

          {/* Legal Disclaimer - Collapsed on mobile */}
          <details className="bg-gray-900 bg-opacity-70 rounded-lg md:rounded-xl p-4 md:p-8 mb-6 md:mb-8 border border-gray-700" data-id="element-961">
            <summary className="text-gray-300 font-semibold cursor-pointer text-sm md:text-base mb-2" data-id="element-962">
              Aviso Legal (clic para expandir)
            </summary>
            <div className="text-gray-400 text-xs md:text-sm leading-relaxed space-y-2 md:space-y-4 mt-4" data-id="element-963">
              <p data-id="element-964">
                48Hrs AI CASH MACHINE y todo el equipo asociado no asume
                responsabilidad por los resultados, ingresos o éxito que puedas
                obtener, ni garantiza resultados específicos. El éxito depende
                en parte del tiempo que dediques y de tu implementación de las
                guías, estrategias y soporte proporcionados.
              </p>
              <p data-id="element-965">
                Los testimonios compartidos corresponden a experiencias reales
                de usuarios, pero no deben considerarse como resultados típicos,
                ya que cada persona obtiene resultados diferentes según su
                situación y las acciones que decida tomar.
              </p>
              <p data-id="element-966">
                Este sitio no forma parte de Google, Google Inc., Facebook/Meta
                o Meta Inc. Además, este sitio no está avalado, patrocinado ni
                aprobado por Google ni Meta de ninguna manera.
              </p>
            </div>
          </details>

          {/* Footer */}
          <div className="text-center text-gray-400 text-xs md:text-sm space-y-2 md:space-y-4" data-id="element-967">
            <p data-id="element-968">
              © 2024 AI Infocommerce Masterclass. Todos los derechos
              reservados.
            </p>
            <p data-id="element-969">
              Soporte:{' '}
              <a href="mailto:support@truemarketer.com" className="text-red-400 hover:text-red-300 underline" data-id="element-970">
                support@truemarketer.com
              </a>
            </p>
            <div className="flex justify-center gap-4" data-id="element-971">
              <a href="#" className="text-red-400 hover:text-red-300 underline" data-id="element-972">
                Términos
              </a>
              <span data-id="element-973">|</span>
              <a href="#" className="text-red-400 hover:text-red-300 underline" data-id="element-974">
                Privacidad
              </a>
            </div>
          </div>
        </div>
      </main>
    </div>;
}